import { Injectable, signal } from '@angular/core';

export type AlertKind = 'ok' | 'error' | 'info';

export interface AlertItem {
    id: number;
    kind: AlertKind;
    text: string;
}

@Injectable({ providedIn: 'root' })
export class AlertService {
    items = signal<AlertItem[]>([]);
    private seq = 0;

    ok(text: string) {
        this.push('ok', text);
    }

    error(text: string) {
        this.push('error', text);
    }

    info(text: string) {
        this.push('info', text);
    }

    dismiss(id: number) {
        this.items.update((list) => list.filter((item) => item.id !== id));
    }

    private push(kind: AlertKind, text: string) {
        const id = ++this.seq;
        this.items.update((list) => [...list, { id, kind, text }]);
        setTimeout(() => this.dismiss(id), 4200);
    }
}
